import { buildSchema,buildProperty } from "@camberi/firecms";

export const shoppingSchema = buildSchema({
    name: "Shopping",
    properties: {
        title: {
            title: "Title",
            validation: { required: true },
            dataType: "string"
        },

        description: {
            title: "Description",
            validation: { required: true },
            dataType: "string",
            config: {
                markdown: true
            }
        },

        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        
        image: buildProperty({
            title: "Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            
        }),

        link_button_text: {
            title: "Link Button Text",
            validation: { required: true },
            dataType: "string"
        },

        link_url: {
            title: "Link Url",
            validation: { required: true },
            dataType: "string"
        },

        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    }
});
